var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"content"},[_vm._v("系统升级中 "),_c('br'),_vm._v(" 敬请期待")])])
}]

export { render, staticRenderFns }